unit PrjDialogLogin;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  WEBLib.Login,
  WEBLib.StdCtrls,
  Vcl.StdCtrls,
  WEBLib.ExtCtrls,
  Vcl.Imaging.pngimage,
  WEBLib.Buttons,
  Vcl.Graphics,
  WEBLib.JSON,
  XData.Web.Client,
  XData.Web.Connection,
  Vcl.Imaging.GIFImg,

  PrjClassHBMDataAccess,
  HBMWebData,
  PrjClassTokenInformation;

type
  TPrjDlgLogin = class(TForm)
    XDataClient: TXDataWebClient;
    WaitMessage: TWaitMessage;
    pnLoginData: TPanel;
    lblLogin: TLabel;
    lblPasswort: TLabel;
    lblLoginError: TLabel;
    WebLabel1: TLabel;
    btnLogin: TButton;
    btnCancel: TButton;
    webedPasswort: TEdit;
    webedLogin: TEdit;


    procedure WebFormCreate(Sender: TObject);
    [async]
    procedure btnLoginClick(Sender: TObject); async;
    procedure btnCancelClick(Sender: TObject);
    procedure webedLoginChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  strict private
    FToken : string;
  private
    FApplicationType: TApplicationTyp;
    FDataAccess: TPrjClassHBMDataAccess;
    FRunAsAdministrator: boolean;
    FRunAsSpielleiter: boolean;
    FTokenInformation: TTokenInformation;
    FLoginMessage : string;
    FWebConnection : TXDataWebConnection;
    function GetDataAccess: TPrjClassHBMDataAccess;
    { Private-Deklarationen }
  public
    [async]
    function Done: TModalResult; async;
    [async]
    function Init: Boolean; async;
    { Public-Deklarationen }
  published
    property WebConnection: TXDataWebConnection read FWebConnection write FWebConnection;
    property LoginMessage: string read FLoginMessage write FLoginMessage;
    property DataAccess: TPrjClassHBMDataAccess read GetDataAccess;
    property ApplicationType: TApplicationTyp read FApplicationType write FApplicationType default atNone;
    property RunAsSpielleiter: boolean read FRunAsSpielleiter write FRunAsSpielleiter default false;
    property RunAsAdministrator: boolean read FRunAsAdministrator write FRunAsAdministrator default false;
  protected procedure LoadDFMValues; override; end;

var
  PrjDlgLogin: TPrjDlgLogin;

implementation

{$I HBMOnline.inc}

uses
  HBMWebDef,
  {$IFDEF APPISADMIN}
  uHBMAdminMain,
  {$ELSE}
    {$IFDEF APPISTLN}
    uHBMMainT,
    {$ELSE}
    PrjFormMain,
    {$ENDIF}
  {$ENDIF}

  wxBaseClassWebTools;


{$R *.dfm}


procedure TPrjDlgLogin.WebFormCreate(Sender: TObject);
begin
  XDataClient.Connection  := WebConnection;
  lblLoginError.Visible   := false;

  if FLoginMessage <> '' then
  begin
    lblLoginError.Visible        := true;
    lblLoginError.Caption        := FLoginMessage;
  end;

//  XDataWebConnection.URL       := cXDataServerUrl;
//  XDataWebConnection.Connected := true;
end;

function TPrjDlgLogin.Done: TModalResult;
begin
//
end;

function TPrjDlgLogin.GetDataAccess: TPrjClassHBMDataAccess;
begin
  if not Assigned(FDataAccess) then
  begin
    FDataAccess := TPrjClassHBMDataAccess.Create(Self);
  end;
  Result := FDataAccess;
end;

function TPrjDlgLogin.Init: Boolean;
begin
  Result             := true;
  webedLogin.Text    := '';
  webedPasswort.Text := '';
end;

procedure TPrjDlgLogin.btnLoginClick(Sender: TObject);
var LResponse : TXDataClientResponse;
begin
  WaitMessage.Show;
  LResponse := Await(XDataClient.RawInvokeAsync('IAuthServices.Login', [webedLogin.Text, webedPasswort.Text, DataAccess.AktuelleSimulation]));
  FToken    := LResponse.ResponseText;
  WaitMessage.Hide;

  DataModule.TokenInformation.BuildJWTStorageName(FToken);

  if pos('ERROR',UpperCase(FToken)) > 0 then
  begin
    wxBaseWriteLog.Write('Login Error - ' + FToken,slDebug);
    FToken := '';
  end;

  if DataModule.TokenInformation.ErrorInfo <> '' then
  begin
    lblLoginError.Visible := true;
    lblLoginError.Caption := 'Fehler bei der Anmeldung ! Benutzername und/oder Passwort falsch...';
    webedLogin.Text    := '';
    webedPasswort.Text := '';
  end else
  begin
    lblLoginError.Visible := false;
    window.localStorage.setItem(DataModule.TokenInformation.TokenStorageName, FToken);

    if Self.RunAsAdministrator then
    begin
      if not DataModule.TokenInformation.isSpielleiter then
      begin
        lblLoginError.Caption := 'Fehler bei der Anmeldung ! Sie wollen sich als Administrator anmelden...';
        lblLoginError.Visible := true;
        window.localStorage.removeItem(DataModule.TokenInformation.TokenStorageName);
        webedLogin.Text    := '';
        webedPasswort.Text := '';
      end;
    end else
    begin
      if Self.RunAsSpielleiter then
      begin
        if not DataModule.TokenInformation.isSpielleiter then
        begin
          lblLoginError.Caption := 'Fehler bei der Anmeldung ! Sie wollen sich als Teilnehmer beim Spielleiter anmelden...';
          lblLoginError.Visible := true;
          window.localStorage.removeItem(DataModule.TokenInformation.TokenStorageName);
          webedLogin.Text    := '';
          webedPasswort.Text := '';
        end else
        begin
          ModalResult := mrOK;
          Close;
        end;
      end else
      begin
        if not DataModule.TokenInformation.isTeilnehmer  then
        begin
          lblLoginError.Caption := 'Fehler bei der Anmeldung ! Sie wollen sich als Spielleiter beim Teilnehmer anmelden...';
          lblLoginError.Visible := true;
          window.localStorage.removeItem(DataModule.TokenInformation.TokenStorageName);
          webedLogin.Text    := '';
          webedPasswort.Text := '';
        end else
        begin
          ModalResult := mrOK;
          Close;
        end;
      end;
    end;
  end;
end;

procedure TPrjDlgLogin.btnCancelClick(Sender: TObject);
begin
  webedLogin.Text       := '';
  webedPasswort.Text    := '';
  lblLoginError.Visible := false;
end;

procedure TPrjDlgLogin.webedLoginChange(Sender: TObject);
begin
  lblLoginError.Visible := false;
end;

procedure TPrjDlgLogin.WebFormShow(Sender: TObject);
begin
  webedLogin.Text    := '';
  webedPasswort.Text := '';
end;

procedure TPrjDlgLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WaitMessage := TWaitMessage.Create(Self);
  pnLoginData := TPanel.Create(Self);
  lblLogin := TLabel.Create('labelLoginUsername');
  lblPasswort := TLabel.Create('labelLoginPassword');
  lblLoginError := TLabel.Create('lblLoginError');
  WebLabel1 := TLabel.Create('lblLoginHeadline');
  btnLogin := TButton.Create('btnLoginSubmit');
  btnCancel := TButton.Create('btnLoginCancel');
  webedPasswort := TEdit.Create('edLoginPassword');
  webedLogin := TEdit.Create('edLoginUsername');
  XDataClient := TXDataWebClient.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pnLoginData.BeforeLoadDFMValues;
  lblLogin.BeforeLoadDFMValues;
  lblPasswort.BeforeLoadDFMValues;
  lblLoginError.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  webedPasswort.BeforeLoadDFMValues;
  webedLogin.BeforeLoadDFMValues;
  XDataClient.BeforeLoadDFMValues;
  try
    Name := 'PrjDlgLogin';
    Width := 1442;
    Height := 806;
    ElementClassName := '!w-full !h-full !flex !justify-center !items-center !top-0 !left-0 bg-[#0008]';
    ElementFont := efCSS;
    ElementPosition := epRelative;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -12;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    Shadow := False;
    ShowClose := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WaitMessage.SetParentComponent(Self);
    WaitMessage.Name := 'WaitMessage';
    WaitMessage.Left := 1160;
    WaitMessage.Top := 384;
    WaitMessage.Width := 24;
    WaitMessage.Height := 24;
    WaitMessage.HeightStyle := ssAuto;
    WaitMessage.WidthStyle := ssAuto;
    WaitMessage.Opacity := 0.20000000000000000;
    WaitMessage.Picture.LoadFromFile('PrjDialogLogin.WaitMessage.Picture.gif');
    pnLoginData.SetParentComponent(Self);
    pnLoginData.Name := 'pnLoginData';
    pnLoginData.Left := 328;
    pnLoginData.Top := 72;
    pnLoginData.Width := 753;
    pnLoginData.Height := 473;
    pnLoginData.HeightStyle := ssAuto;
    pnLoginData.WidthStyle := ssAuto;
    pnLoginData.Caption := 'pnLoginData';
    pnLoginData.ChildOrder := 9;
    pnLoginData.ElementFont := efCSS;
    pnLoginData.ElementPosition := epIgnore;
    pnLoginData.ShowCaption := False;
    pnLoginData.TabOrder := 1;
    lblLogin.SetParentComponent(pnLoginData);
    lblLogin.Name := 'lblLogin';
    lblLogin.Left := 48;
    lblLogin.Top := 51;
    lblLogin.Width := 200;
    lblLogin.Height := 40;
    lblLogin.Caption := 'Anmeldename';
    lblLogin.ElementClassName := 'text-inherit';
    lblLogin.ElementFont := efCSS;
    lblLogin.ElementPosition := epRelative;
    lblLogin.Font.Charset := DEFAULT_CHARSET;
    lblLogin.Font.Color := clWindowText;
    lblLogin.Font.Height := -29;
    lblLogin.Font.Name := 'Segoe UI';
    lblLogin.Font.Style := [fsBold];
    lblLogin.HeightStyle := ssAuto;
    lblLogin.HeightPercent := 100.00000000000000000;
    lblLogin.ParentFont := False;
    lblLogin.WidthStyle := ssAuto;
    lblLogin.WidthPercent := 100.00000000000000000;
    lblPasswort.SetParentComponent(pnLoginData);
    lblPasswort.Name := 'lblPasswort';
    lblPasswort.Left := 48;
    lblPasswort.Top := 163;
    lblPasswort.Width := 124;
    lblPasswort.Height := 40;
    lblPasswort.Caption := 'Passwort';
    lblPasswort.ElementFont := efCSS;
    lblPasswort.ElementPosition := epRelative;
    lblPasswort.Font.Charset := DEFAULT_CHARSET;
    lblPasswort.Font.Color := clWindowText;
    lblPasswort.Font.Height := -29;
    lblPasswort.Font.Name := 'Segoe UI';
    lblPasswort.Font.Style := [fsBold];
    lblPasswort.HeightStyle := ssAuto;
    lblPasswort.HeightPercent := 100.00000000000000000;
    lblPasswort.ParentFont := False;
    lblPasswort.WidthStyle := ssAuto;
    lblPasswort.WidthPercent := 100.00000000000000000;
    lblLoginError.SetParentComponent(pnLoginData);
    lblLoginError.Name := 'lblLoginError';
    lblLoginError.Left := 152;
    lblLoginError.Top := 37;
    lblLoginError.Width := 360;
    lblLoginError.Height := 15;
    lblLoginError.Caption := 'Die Kombination aus Username und Passwort ist leider nicht korrekt.';
    lblLoginError.ElementFont := efCSS;
    lblLoginError.ElementPosition := epRelative;
    lblLoginError.HeightStyle := ssAuto;
    lblLoginError.HeightPercent := 100.00000000000000000;
    lblLoginError.Visible := False;
    lblLoginError.WidthPercent := 100.00000000000000000;
    WebLabel1.SetParentComponent(pnLoginData);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 256;
    WebLabel1.Top := 16;
    WebLabel1.Width := 101;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'HBM - Anmeldung';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epRelative;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.00000000000000000;
    WebLabel1.HTMLType := tH2;
    WebLabel1.WidthPercent := 100.00000000000000000;
    btnLogin.SetParentComponent(pnLoginData);
    btnLogin.Name := 'btnLogin';
    btnLogin.Left := 416;
    btnLogin.Top := 358;
    btnLogin.Width := 209;
    btnLogin.Height := 72;
    btnLogin.ButtonType := 'button';
    btnLogin.Caption := 'Anmelden';
    btnLogin.ChildOrder := 7;
    btnLogin.Default := True;
    btnLogin.ElementClassName := 'btn btn-primary';
    btnLogin.ElementFont := efCSS;
    btnLogin.ElementPosition := epRelative;
    btnLogin.HeightStyle := ssAuto;
    btnLogin.HeightPercent := 100.00000000000000000;
    btnLogin.WidthStyle := ssAuto;
    btnLogin.WidthPercent := 100.00000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
    btnCancel.SetParentComponent(pnLoginData);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 48;
    btnCancel.Top := 360;
    btnCancel.Width := 209;
    btnCancel.Height := 68;
    btnCancel.Cancel := True;
    btnCancel.Caption := 'Abbrechen';
    btnCancel.ChildOrder := 8;
    btnCancel.ElementClassName := 'btn btn-outline';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    webedPasswort.SetParentComponent(pnLoginData);
    webedPasswort.Name := 'webedPasswort';
    webedPasswort.Left := 48;
    webedPasswort.Top := 209;
    webedPasswort.Width := 609;
    webedPasswort.Height := 56;
    webedPasswort.ChildOrder := 7;
    webedPasswort.ElementClassName := 'input input-bordered w-full';
    webedPasswort.ElementFont := efCSS;
    webedPasswort.ElementPosition := epRelative;
    webedPasswort.HeightStyle := ssAuto;
    webedPasswort.HeightPercent := 100.00000000000000000;
    webedPasswort.PasswordChar := '*';
    webedPasswort.TabOrder := 1;
    webedPasswort.Text := 'webedPasswort';
    webedPasswort.WidthStyle := ssAuto;
    webedPasswort.WidthPercent := 100.00000000000000000;
    SetEvent(webedPasswort, Self, 'OnChange', 'webedLoginChange');
    webedLogin.SetParentComponent(pnLoginData);
    webedLogin.Name := 'webedLogin';
    webedLogin.Left := 48;
    webedLogin.Top := 97;
    webedLogin.Width := 609;
    webedLogin.Height := 60;
    webedLogin.ChildOrder := 7;
    webedLogin.ElementClassName := 'input input-bordered w-full';
    webedLogin.ElementFont := efCSS;
    webedLogin.ElementPosition := epRelative;
    webedLogin.HeightStyle := ssAuto;
    webedLogin.HeightPercent := 100.00000000000000000;
    webedLogin.Text := 'webedLogin';
    webedLogin.WidthStyle := ssAuto;
    webedLogin.WidthPercent := 100.00000000000000000;
    SetEvent(webedLogin, Self, 'OnChange', 'webedLoginChange');
    XDataClient.SetParentComponent(Self);
    XDataClient.Name := 'XDataClient';
    XDataClient.Left := 1160;
    XDataClient.Top := 288;
  finally
    WaitMessage.AfterLoadDFMValues;
    pnLoginData.AfterLoadDFMValues;
    lblLogin.AfterLoadDFMValues;
    lblPasswort.AfterLoadDFMValues;
    lblLoginError.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    webedPasswort.AfterLoadDFMValues;
    webedLogin.AfterLoadDFMValues;
    XDataClient.AfterLoadDFMValues;
  end;
end;

end.
